import { Route } from 'react-router-dom';
import NotFoundPage from '../../pages/errors/not-found.page';
import NoAccessPage from '../../pages/errors/not-access.page';

export const ErrorsRoutes = <Route path="*" element={<NotFoundPage />} />;
export const NoAccessRoutes = <Route path="/no-access" element={<NoAccessPage />} />;
